<template>
    <v-container class="main-header py-0" :class="{'isCheckout': isCheckout}">
        <v-row>
            <v-col cols="8" sm="8" md="4" class="pa-0">
                <router-link to="/" class="main-link">
                    <img :src="require('../../assets/Praha_9_logo_menu.png')" class="custom-logo" :class="{'isCheckout': isCheckout}" itemprop="logo" />
                </router-link>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="main-title pa-0 ma-0" v-if="$vuetify.breakpoint.mdAndUp">
                <div class="d-flex justify-center align-center fill-height">
                    <strong>Devítka na lepší časy</strong>
                </div>
            </v-col>
            <v-col cols="4" sm="4" md="4" class="header-cart pa-0 ma-0">
                <div v-if="!isCheckout" class="d-flex justify-end align-center cart-header fill-height">
                    <v-btn href="https://docs.google.com/forms/d/e/1FAIpQLSedXsfA6_KECOBetvyQAwJiUxzVGCe05BRITqV6NMmDCKw7Dw/viewform" target="_blank" small outlined color="white" class="mr-3" v-if="$vuetify.breakpoint.smAndUp">Chci se zapojit</v-btn>
                    <span @click="drawer = true">
                         <v-badge
                                 :content="itemsInCart"
                                 :value="itemsInCart"
                                 :color="badgeColor"
                                 overlap
                                 class="main-cart align-center"
                         >
                        <img class="cart-image" :src="require('../../assets/shoppingcart.svg')" :class="{mobileCart: $vuetify.breakpoint.xsOnly}" />
                    </v-badge>
                    </span>
                </div>
            </v-col>
        </v-row>

        <v-navigation-drawer
                temporary
                v-model="drawer"
                :right="true"
                fixed
                width="340"
        >
            <cart-overlay @drawerClose="drawer = false" />
        </v-navigation-drawer>
    </v-container>
</template>

<script>
    import {mapGetters} from 'vuex'
    import CartOverlay from '../Cart/CartOverlay'

    export default {
        name: 'MainHeader',
        props: ['isCheckout'],
        data () {
            return {
                drawer: false
            }
        },
        components: {
            CartOverlay
        },
        computed: {
            ...mapGetters([
                'cartProducts'
            ]),
            itemsInCart() {
                let cart = this.cartProducts;
                if (!cart[0]) return null;
                return cart.reduce((accum, item) => accum + item.qty, 0)
            },
            badgeColor() {
                if (this.$vuetify.breakpoint.smAndUp) {
                    return 'primary';
                }

                return 'secondary';
            }
        }
    }
</script>

<style lang="scss">
    .main-header {
        .main-link {
            line-height: 0;
        }
        .main-cart {
            display: inline-flex;
            cursor: pointer;
        }
        .cart-title {
            display: inline-flex;
            margin-top: 5px;
            color: #FFFFFF;
        }
        .cart-image {
            cursor: pointer;
            width: 40px;
        }
        .mobileCart {
            max-width: 80px;
        }

        &.isCheckout {
            padding-top: 0;
            padding-bottom: 0;
        }
        .menu-item {
            a {
                padding: 0 1em;
                font-size: 16px;
                color: #FFFFFF !important;
                text-decoration: none;
                text-transform: uppercase;
                &:hover {
                    opacity: 0.7;
                }
            }
        }
        .main-title {
            background-image: url('../../assets/vlna_bila2-modra.png'), linear-gradient(to right, #10529e, #10529e);
            background-size: contain;
            background-repeat: no-repeat;
            color: #FFFFFF;
            text-align: center;
            strong {
                margin-left: 90px;
                display: block;
                font-weight: 700;
                font-size: 24px;
                line-height: 24px;
            }
        }
        .header-cart {
            background-image: url('../../assets/vlna_modra-zelena.png'), linear-gradient(to right, #4b982b, #4b982b);
            background-size: contain;
            background-repeat: no-repeat;
            @media #{$phone-strict} {
                background-image: url('../../assets/vlna_bila2-modra.png'), linear-gradient(to right, #10529e, #10529e);
            }
            @media #{$pixel-less-phone} {
                background-image: url('../../assets/vlna_bila2-modra.png'), linear-gradient(to right, #10529e, #10529e);
            }
        }
        .custom-logo {
            max-width: 180px;
        }
        .menu-icon-link {
            border-radius: 7px !important;
        }
        .v-list, .v-menu__content {
            border-radius: 0 !important;
        }
        .v-menu__content {
            max-width: 100% !important;
            width: 100%;
            left: 0 !important;
        }
        .v-chip {
            .v-chip__content {
                cursor: pointer !important;
            }
        }
        .opening-hours {
            strong {
                display: block;
                font-weight: 600;
                font-size: 14px;
            }
        }
    }
</style>
